import React, { useContext } from 'react';
import { Avatar, Button, ButtonType } from '@yy/tofu-ui-react';
import { LoginStatusContext, UserInfoContext, UserRoleContext } from '../App';
import { isGuild, convertHttps } from '../util';
import styled from 'styled-components';

const overWriteButtonStyle = {
  width: 240,
  height: 46,
  borderRadius: 56,
  fontSize: 16,
  color: '#1d1d1d',
  flexShrink: 0
};

const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

const FlexColum = styled(FlexRow)`
  flex-direction: column;
`;

const UserName = styled.span`
  display: inline-block;
  margin: 10px 0 7px;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  height: 18px;
  letter-spacing: 0.28px;
  color: #111111;
`;

const YYNum = styled.span`
  display: inline-block;
  margin-bottom: 12px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.24px;
  color: #999999;
`;

const LoginModule = () => {
  const isLoggedIn = useContext(LoginStatusContext);
  const userRole = useContext(UserRoleContext);
  const userInfo = useContext(UserInfoContext);

  function goToBeGuildPage() {
    window.open('//www.yy.com/gh/cl/?a=1', '_blank');
  }

  function goLogin() {
    window.user?.showYYLoginBox();
  }

  function goToUserCenter() {
    window.open('//www.yy.com/gi?path=/i/index/anchor&hash=', '_blank');
  }

  return (
    <div className="login-module">
      <div className="login-module-wrap">
        <div className="login-module-content">
          {isLoggedIn ? (
            // 已登录
            isGuild(userRole) ? (
              // 公会身份
              <>
                <FlexColum>
                  <Avatar
                    src={convertHttps(userInfo.logo as string)}
                    style={{ width: 60, height: 60 }}
                  />
                  <UserName>{userInfo.guildName || userInfo.nick}</UserName>
                  <YYNum>YY: {userInfo.yy_num}</YYNum>
                </FlexColum>
                <Button
                  type={ButtonType.Emphasis}
                  style={overWriteButtonStyle}
                  onClick={goToUserCenter}
                >
                  公会管理后台
                </Button>
              </>
            ) : (
              // 主播身份 + 普通用户
              <>
                <FlexColum>
                  <Avatar
                    src={convertHttps(userInfo.logo as string)}
                    style={{ width: 60, height: 60 }}
                  />
                  <UserName>{userInfo.nick}</UserName>
                  <YYNum>YY: {userInfo.yy_num}</YYNum>
                </FlexColum>
                <Button
                  type={ButtonType.Normal}
                  style={overWriteButtonStyle}
                  onClick={goToBeGuildPage}
                >
                  欢迎成为公会
                </Button>
              </>
            )
          ) : (
            // 未登录
            <>
              <Button
                type={ButtonType.Emphasis}
                style={overWriteButtonStyle}
                onClick={goLogin}
              >
                公会登录
              </Button>

              <Button
                type={ButtonType.Normal}
                style={{ ...overWriteButtonStyle, marginTop: 30 }}
                onClick={goToBeGuildPage}
              >
                欢迎成为公会
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginModule;
